// extracted by mini-css-extract-plugin
export default {"feedback":"Feedback_feedback__69etg","feedbackOverlay":"Feedback_feedbackOverlay__5eh9q"};